var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHalfStar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 22,
    viewBox: "0 0 23 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.66602 8.24219H0L7.01172 13.3359L4.33301 21.5781L11.3438 16.4844L18.3555 21.5781L15.6777 13.3359L22.6885 8.24219H14.0215L11.3438 0L8.66602 8.24219ZM13.2959 9.24219H19.6104L14.502 12.9541L16.4531 18.9609L11.3438 15.248L6.23535 18.9609L8.18652 12.9541L3.07715 9.24219H9.39258L11.3438 3.23633L13.2959 9.24219Z",
    fill: "#FD9F35"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.4746 15.7363V1.73633L9.3573 9.23633H2.97461L7.97461 13.2363L5.97461 19.2363L11.4746 15.7363Z",
    fill: "#FD9F35"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHalfStar);
export default __webpack_public_path__ + "static/media/half-star.ded2cfb6396a270a24f7f59f1d578cb0.svg";
export { ForwardRef as ReactComponent };